/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Fatura_TitleInputs */

const tr_faq_cat_fatura_title = /** @type {(inputs: Faq_Cat_Fatura_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura ve Faturalama`)
};

const en_faq_cat_fatura_title = /** @type {(inputs: Faq_Cat_Fatura_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Invoice & Billing`)
};

const de_faq_cat_fatura_title = /** @type {(inputs: Faq_Cat_Fatura_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Rechnung`)
};

const ru_faq_cat_fatura_title = /** @type {(inputs: Faq_Cat_Fatura_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронные счета`)
};

/**
* | output |
* | --- |
* | "e-Invoice & Billing" |
*
* @param {Faq_Cat_Fatura_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_fatura_title = /** @type {((inputs?: Faq_Cat_Fatura_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Fatura_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_fatura_title(inputs)
	if (locale === "de") return de_faq_cat_fatura_title(inputs)
	if (locale === "ru") return ru_faq_cat_fatura_title(inputs)
	return tr_faq_cat_fatura_title(inputs)
});